<style scoped>

</style>

<template>
  <span>
    <slot slot-scope="scope"></slot>
    <mu-dialog :title="title" scrollable max-width="100%" :esc-press-close="false" :overlay-close="false" :open.sync="editing">
        <mu-form :model="data" label-position="top" label-width="100">
          <mu-radio v-model="modelEditFile" :value="false" :label="$t('media.editFileFalse')" v-if="!create"></mu-radio>
          <mu-radio v-model="modelEditFile" :value="true" :label="$t('media.editFileTrue')" v-if="!create"></mu-radio>
          <div v-if="modelEditFile">
            <mu-tabs :value.sync="modelTabMedia" full-width inverse @change="onChangeTabMedia">
              <mu-tab>{{$t('media.file_upload')}}</mu-tab>
              <mu-tab>{{$t('media.youtube')}}</mu-tab>
              <mu-tab>{{$t('media.wysiwyg')}}</mu-tab>
              <mu-tab>{{$t('media.mp4link')}}</mu-tab>
            </mu-tabs>
            <div v-if="modelTabMedia === 0">
              <input type="file" id="file" ref="file" @change="onChangeFile" />
            </div>
            <div v-if="modelTabMedia === 1">
              <mu-form-item prop="input" :label="$t('media.youtube')">
                <mu-text-field v-model="modelYoutube"></mu-text-field>
              </mu-form-item>
              <video-player
                class="vjs-default-skin video-player"
                ref="videoPlayer"
                :options="playerOptions"
                :playsinline="true"
                @playing="onPlay"
                />
            </div>
            <div v-if="modelTabMedia === 3">
              <mu-form-item prop="input" :label="$t('media.mp4link')">
                <mu-text-field v-model="modelMp4"></mu-text-field>
              </mu-form-item>
              <video-player
                class="vjs-default-skin video-player"
                ref="videoPlayer"
                :options="mp4PlayerOptions"
                :playsinline="true"
                @playing="onPlay"
                />
            </div>
          </div>
          <mu-divider/>
          <mu-form-item prop="input" :label="$t('media.title') + $t('space') + $t('prompt.name')">
            <mu-text-field v-model="data.name"></mu-text-field>
          </mu-form-item>
          <mu-form-item prop="textarea" :label="$t('media.description')">
            <mu-text-field multi-line :rows="3" :rows-max="6" v-model="data.description"></mu-text-field>
          </mu-form-item>
          <mu-form-item prop="radio" :label="$t('media.volatility')" label-width="300" v-if="type === 'video'">
            <mu-radio v-model="data.volatility" :value="false" :label="$t('radio.no')"></mu-radio>
            <mu-radio v-model="data.volatility" :value="true" :label="$t('radio.yes')"></mu-radio>
          </mu-form-item>
      </mu-form>
      <mu-button slot="actions" flat color="primary" @click="onActionCancel"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
      <mu-button slot="actions" flat color="primary" @click.prevent="onActionEdit" :disabled="isReadyEdit"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
    </mu-dialog>
    <mu-dialog :title="$t('button.delete') + $t('space') + $t('media.title')" scrollable max-width="100%" :esc-press-close="false" :overlay-close="false" :open.sync="deleting">
        {{stringDelete}}
        <mu-button slot="actions" flat color="primary" @click="onActionCancel"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
        <mu-button slot="actions" flat color="primary" @click="onActionDelete"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
    </mu-dialog>
    <mu-dialog :title="$t('button.edit') + $t('space') + $t('media.thumbnail')" scrollable max-width="100%" :esc-press-close="false" :overlay-close="false" :open.sync="thumbnail">
      <mu-row gutter>
        <mu-col span="4" sm="12" md="6" lg="4" xl="4" offset="4">
          <img class="img-thumbnail full-width full-height" :src="thumbnailSource">
        </mu-col>
      </mu-row>
      <br />
      <mu-row gutter>
        <mu-col span="3" sm="6" md="3" lg="3" xl="3" :key="index" v-if="data.type === 'video'" v-for="index in thumbnailIndex">
          <img :src="thumbnailSourceIndex(index)" class="full-width">
          <mu-radio v-model="modelThumbnail" :value="thumbnailSourceIndex(index)"></mu-radio>
        </mu-col>
      </mu-row>
      <mu-row gutter>
        <mu-col span="3" sm="6" md="3" lg="3" xl="3" :key="index" v-if="data.type === 'youtube'" v-for="(item, index) in thumbnailYoutube">
          <img :src="stringThumbnailYoutube(item)" class="full-width">
          <mu-radio v-model="modelThumbnail" :value="item"></mu-radio>
        </mu-col>
      </mu-row>
      <br />
      <mu-radio v-model="modelThumbnail" :value="thumbnailSourceIndex(999)"></mu-radio>
      <input type="file" id="file" ref="thumbnail" @change="onChangeFileThumbnail" />
      <mu-button slot="actions" flat color="primary" @click="onActionCancel"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
      <mu-button slot="actions" flat color="primary" @click="onActionThumbnail" :disabled="!isValidThumbnail"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
    </mu-dialog>
    <mu-dialog :title="$t('button.access')" scrollable max-width="100%" width="1024px" :esc-press-close="false" :overlay-close="false" :open.sync="access">
      <mu-form :model="data">
          <mu-form-item prop="select" :label="$t('media.accessMode.display')">
            <mu-select v-model="data.access_mode">
              <mu-option :label="$t('media.accessMode.enrolled')" :value="0"></mu-option>
              <mu-option :label="$t('media.accessMode.close')" :value="1"></mu-option>
            </mu-select>
          </mu-form-item>
          <mu-data-table selectable select-all :selects.sync="modelAccessWhitelist" checkbox :columns="columns" stripe :data="enrollments" :no-data-text="$t('empty.noDataTitle')" v-if="data.access_mode === 1">
            <template slot-scope="scope">
              <td>{{scope.row.user.name}} ({{scope.row.user.username}})</td>
              <td>{{scope.row.user.email}}</td>
            </template>
          </mu-data-table>
      </mu-form>
      <mu-button slot="actions" flat color="primary" @click="onActionCancel"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
      <mu-button slot="actions" flat color="primary" @click="onActionAccess"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
    </mu-dialog>
    <mu-dialog :title="$t('media.subtitle')" scrollable max-width="100%" width="1024px" :esc-press-close="false" :overlay-close="false" :open.sync="subtitle">
      <mu-form :model="data">
        <div>
          <div v-for="(sub, index) in subtitles">{{sub}}<a href="javascript:void(0)" @click="onClickDeleteSubtitle(index)"><mu-icon value="delete" /></a></div>
        </div>
        <mu-divider/>
        <div>
          <mu-button color="primary" @click="$refs.subtitles.click()">{{$t('button.add') + $t('space') + $t('media.subtitle')}}</mu-button>
          <input type="file" id="file" ref="subtitles" @change="onChangeFileSubtitles" multiple style="display: none;"/>
          <span style="padding-left: 8px;" v-for="(sub, index) in modelSubtitles">{{modelSubtitles[index].name}}</span>
        </div>
      </mu-form>
      <mu-button slot="actions" flat color="primary" @click="onActionCancel"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
      <mu-button slot="actions" flat color="primary" @click="onActionSubtitle" :disabled="modelSubtitles.length === 0"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
    </mu-dialog>
  </span>
</template>

<script>
// Utils
import youtubeParser from '@/utils/youtubeParser.js'

import media from '@/mixins/media.js'

import mime from 'mime-types'
import 'videojs-youtube'

import VideoPlayer from '@/components/Common/VideoPlayer.vue'

export default {
  name: 'ManageMedia',
  mixins: [media],
  components: {
    VideoPlayer,
  },
  props: {
    value: {
      type: Object,
      default() {
        return {
          name: "",
          content: "",
          description: "",
          volatility: false
        };
      }
    },
    editing: {
      type: Boolean,
      default: false
    },
    subtitle: {
      type: Boolean,
      default: false
    },
    deleting: {
      type: Boolean,
      default: false
    },
    thumbnail: {
      type: Boolean,
      default: false
    },
    access: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    create: {
      type: Boolean,
      default: false
    },
    enrollments: {
      type: Array,
      default() {
        return [];
      }
    },
    type: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      // Constant
      thumbnailIndex: [0,1,2,3,4,5,6,7],
      thumbnailYoutube: ["0", "1", "2", "3", "hqdefault", "mqdefault", "maxresdefault"],
      
      data: JSON.parse(JSON.stringify(this.value)),
      
      modelEditFile: this.create,
      modelFilename: "",
      modelFile: "",
      modelType: "",
      modelYoutube: "",
      modelMp4: "",      
      modelThumbnail: this.value.hasOwnProperty('thumbnail') ? this.value.thumbnail : '',
      modelFileThumbnail: "",
      modelAccessWhitelist: [],
      modelSubtitles: [],
      subtitles: this.value.hasOwnProperty('subtitles') ? this.value.subtitles : [],
      
      modelTabMedia: 0,
      
      ready: false,
      duration: 0,
    }
  },
  computed: {
    // Flag
    isPlaylistNameEmpty() {
      return this.data.name === '';
    },
    isReadyEdit() {
      if(this.modelEditFile) {
        if(this.modelTabMedia === 0)
          return !this.isValidFile || this.isNameEmpty;
        else if(this.modelTabMedia === 1)
          return this.isYoutubeEmpty || this.isNameEmpty || !this.ready;
        else if(this.modelTabMedia === 2)
          return this.isNameEmpty;
        else if(this.modelTabMedia === 3)
          return this.isMp4Empty || this.isNameEmpty || !this.ready;
        else
          return false;
      } else {
        return this.isNameEmpty;
      }
    },
    isValidFile() {
      if (this.modelType === "unknown" || this.modelType === "empty") {
        return false;
      } else {
        return true;
      }
    },
    isNameEmpty() {
      if (this.data.name === "") {
        return true;
      } else {
        return false;
      }
    },
    isYoutubeEmpty() {
      if (this.modelYoutube === "") {
        return true;
      } else {
        return false;
      }
    },
    isMp4Empty() {
      if (this.modelMp4 === "") {
        return true;
      } else {
        return false;
      }
    },
    isValidThumbnail() {
      if(this.modelThumbnail == '999' && this.modelFileThumbnail == "")
        return false;
      else
        return true;
    },
    
    // String
    stringDelete() {
      return this.$t('prompt.deleteMsg', { name: this.data.name });
    },
    
    // Video.js
    player() { // Return player instance
      return this.$refs.videoPlayer.player
    },
    playerOptions() { // Options for player
      return {
        autoplay: true,
        language: this.$i18n.locale(),
        sources: [{
            type: "video/youtube",
            src: "//www.youtube.com/watch?v=" + youtubeParser(this.modelYoutube),
        }],
        techOrder: ["youtube"],
        poster: "",
        fluid: true,
        controlBar: false
      }
    },
    mp4PlayerOptions() { // Options for MP4 player
      return {
        autoplay: true,
        language: this.$i18n.locale(),
        sources: [{
            type: "video/mp4",
            src: this.modelMp4,
        }],
        techOrder: ["html5"],
        poster: "",
        fluid: true,
        controlBar: false
      }
    },    
    // Table Columns
    columns() {
      var array = [
        { title: this.$t('profile.username'), name: 'username' },
        { title: this.$t('profile.email'), name: 'email' },
      ];
      return array;
    },
    
    // Computed Array
    computedModelAccessWhitelist() {
      if(Array.isArray(this.modelAccessWhitelist) && this.modelAccessWhitelist.length > 0) {
        var d = [];
        this.modelAccessWhitelist.forEach(i => {
          if(typeof this.enrollments[i] !== 'undefined') {
            d.push(this.enrollments[i].user._id)
          }
        });
        return d;
      } else {
        return [];
      }
    },
  },
  watch: {
    data: {
      handler(newValue) {
        this.$emit('input', newValue);
      },
      deep: true
    },
    value: {
      handler(newValue) {
        if(typeof this.data._id !== 'undefined' && this.data._id !== newValue._id) {
          this.data = JSON.parse(JSON.stringify(this.value))
        }
      },
      deep: true
    },
    modelYoutube() {
      this.ready = false;
    },
    modelMp4() {
      this.ready = false;
    },
    editing(newValue) {
      if(this.create && newValue) {
        this.data = {
          name: "",
          content: "",
          description: "",
          volatility: false
        };
        this.modelTabMedia = 0;
      }
    },
  },
  mounted() {
    this.data = Object.assign({}, {
      name: "",
      content: "",
      description: "",
      volatility: false
    }, this.value);
    if(this.value.hasOwnProperty('access_whitelist') ) {
      var model = [];
      this.value.access_whitelist.forEach(item => {
        var index = this.enrollments.findIndex(i => i.user_id === item);
        
        model.push(index);
      });
      
      this.modelAccessWhitelist = model;
    }
  },
  methods: {
    onActionCancel() {
      this.$emit('cancel');
    },
    onActionEdit() {
      var upload = false;
      var data = {
        name: this.data.name,
        description: this.data.description ? this.data.description : "",
        volatility: this.data.volatility
      };
      let formData = new FormData();
      if(this.modelTabMedia === 0 && this.modelEditFile) {
        data['type'] = this.modelType;
        data['content'] = this.modelFilename;
        
        formData.append('file', this.modelFile);
        
        upload = true;
      } else if(this.modelTabMedia === 1) {
        data['type'] = 'youtube';
        data['content'] = youtubeParser(this.modelYoutube);
        data['duration'] = this.duration;
      } else if(this.modelTabMedia === 2) {
        data['type'] = 'wysiwyg';
      } else if(this.modelTabMedia === 3) {
        data['type'] = 'mp4link';
        data['content'] = this.modelMp4;
        data['duration'] = this.duration;
      }
      this.$emit('save', {
        file: formData, 
        data: data,
        upload: upload
      });
    },
    onClickDeleteSubtitle(index) {
      this.subtitles.splice(index, 1);
      var data = {
        subtitles: this.subtitles
      };
      
      let formData = new FormData();
      this.$emit('save', {
        file: formData, 
        data: data,
        upload: false
      });
    },
    onActionDelete() {
      this.$emit('delete');
    },
    onActionThumbnail() {
      let formData = new FormData();
      formData.append('_method', "PUT");
      formData.append('thumbnail', this.modelThumbnail);
      if(this.modelThumbnail == this.thumbnailSourceIndex(999)) {
        formData.append('file', this.modelFileThumbnail);
      }
      this.$emit('thumbnail', formData);
    },
    onActionAccess() {
      this.data.access_whitelist = this.computedModelAccessWhitelist;
      this.$emit('save', this.data);
    },
    onActionSubtitle() {
      let formData = new FormData();
      formData.append('_method', "PUT");
      for( var i = 0; i < this.modelSubtitles.length; i++ ){
        let file = this.modelSubtitles[i];

        formData.append('file[' + i + ']', file);
      }
      this.$emit('subtitle', formData);
    },
    onChangeFile() {
      if (this.$refs.file.files[0] != undefined) {
        this.modelFile = this.$refs.file.files[0];
        this.modelFilename = this.$refs.file.files[0].name;
        var type = mime.lookup(this.modelFilename);
        if (type === "image/jpeg" || type === "image/png") {
          this.modelType = "img";
          if(this.data.name === "") this.data.name = this.mapFileToName(this.modelFilename);
        } else if (type === "video/mp4") {
          this.modelType = "video";
          if(this.data.name === "") this.data.name = this.mapFileToName(this.modelFilename);
        } else if (type === "application/pdf") {
          this.modelType = "pdf";
          if(this.data.name === "") this.data.name = this.mapFileToName(this.modelFilename);
        } else if (type === "application/sla" || type === "application/vnd.ms-pki.stl" || type === "application/x-navistyle") {
          this.modelType = "stl";
          if(this.data.name === "") this.data.name = this.mapFileToName(this.modelFilename);
        } else if (type === "application/x-tgif") {
          this.modelType = "obj";
          if(this.data.name === "") this.data.name = this.mapFileToName(this.modelFilename);
        } else if (type === "application/json") {
          this.modelType = "three";
          if(this.data.name === "") this.data.name = this.mapFileToName(this.modelFilename);
        } else if (type === "model/vnd.collada+xml") {
          this.modelType = "collada";
          if(this.data.name === "") this.data.name = this.mapFileToName(this.modelFilename);
        } else {
          this.modelType = "unknown";
          this.modelFile = ""
          this.modelFilename = "";
        }
      } else {
        this.modelType = "empty";
        this.modelFile = ""
        this.modelFilename = "";
      }
    },
    onChangeFileThumbnail() {
      if (this.$refs.thumbnail.files[0] != undefined) {
        this.modelFileThumbnail = this.$refs.thumbnail.files[0];
        this.modelThumbnail = this.thumbnailSourceIndex(999);
      } else {
        this.modelFileThumbnail = "";
        this.modelThumbnail = 0;
      }
    },
    onChangeFileSubtitles() {
      if (this.$refs.subtitles.files[0] != undefined) {
        this.modelSubtitles = this.$refs.subtitles.files;
      } else {
        this.modelSubtitles = [];
      }
    },
    onChangeTabMedia(activeTab) {
      this.modelTabMedia = activeTab;
    },
    
    // Video.js
    onPlay(payload) {
      this.ready = true;
      this.duration = payload.duration;
    },
    
    // String
    thumbnailSourceIndex(num) {
      if(this.data.hasOwnProperty('thumbnail') && typeof this.data.thumbnail === 'string') {
        var split = this.data.thumbnail.split('/');
        split.pop();
        return split.join('/') + '/' + num + '.png';
      } else {
        return "";
      }
    },
  }
}
</script>
